import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { blogData } from "../utils/blogData";

const BlogPage = () => {
  const navigate = useNavigate();

  const canonicalUrl = "https://buildpro.ogcs.co.in/blogPage";

  return (
    <>
      <Helmet>
        <title>Blogs - BuildPro OGCS</title>
        <meta
          name="description"
          content="Explore construction insights and GFRP innovations through BuildPro OGCS blogs. Stay updated with trends and expert articles."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Blogs - BuildPro OGCS" />
        <meta
          property="og:description"
          content="Explore how BuildPro OGCS helps manufacturers and suppliers grow in the Indian construction market."
        />
        <meta property="og:url" content={canonicalUrl} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blogs - BuildPro OGCS" />
        <meta
          name="twitter:description"
          content="Learn more about our GFRP innovation, supplier growth and construction trends."
        />

        {/* JSON-LD: Blog */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Blog",
          "name": "BuildPro OGCS Blog",
          "url": canonicalUrl,
          "description":
            "Construction insights, GFRP innovations, and market trends from BuildPro OGCS."
        })}</script>
      </Helmet>

      <main className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* ✅ Single H1 on this page */}
        <h1 className="text-4xl sm:text-5xl font-extrabold text-center text-gray-800 mb-12">
          BuildPro OGCS Blog
        </h1>

        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {Array.isArray(blogData) && blogData.length > 0 ? (
            blogData.map((blog, index) => (
              <article
                key={blog.id}
                className={`bg-white/80 backdrop-blur-lg border border-gray-200 rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 hover:scale-[1.02] transform transition duration-300 ease-in-out animate-fade-in delay-${index * 75}`}
              >
                {blog.image && (
                  <img
                    src={blog.image}
                    alt={blog.title}
                    loading="lazy"
                    className="rounded-t-2xl w-full h-52 object-cover"
                  />
                )}

                <div className="p-6 flex flex-col flex-grow">
                  {/* Card title as H2 (not H1) */}
                  <h2 className="text-lg font-bold text-gray-800 mb-2 hover:text-blue-600 transition">
                    {blog.title}
                  </h2>

                  <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                    {blog.summary}
                  </p>

                  <button
                    onClick={() => navigate(`/blog/${blog.slug}`)}
                    className="mt-auto bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-sm font-semibold px-5 py-2 rounded-lg transition-all duration-200 shadow-md"
                    aria-label={`Read more: ${blog.title}`}
                  >
                    Read More →
                  </button>
                </div>
              </article>
            ))
          ) : (
            <p className="text-red-500 col-span-full text-center">
              No blog data available.
            </p>
          )}
        </div>

        <div className="fixed bottom-6 right-6 z-50">
          <button
            onClick={() => navigate("/")}
            className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-sm font-semibold px-5 py-2 rounded-lg transition-all duration-200 shadow-md"
          >
            ← Go to Home
          </button>
        </div>
      </main>
    </>
  );
};

export default BlogPage;
